<template>
  <div class="app-container">
    <div class="app-content">
      <el-select
        v-model="device.selectedId"
        size="small"
        class="device-select__container"
        :placeholder="$t('placeholder.qxxsb')"
        @change="handleDeviceChange"
      >
        <el-option v-for="(item, index) in device.list" :key="index" :label="item.key" :value="item.value" />
      </el-select>

      <!-- 汇总概览数据 -->
      <div
        v-show="isSummary"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="summary-overview"
      >
        <!-- 光伏发电汇总 -->
        <el-card class="overview-item">
          <template #header>
            <strong>
              光伏发电汇总
            </strong>
          </template>
          <template #default>
            <div v-show="!isPhotovoltaicEmptyData" class="content-container">
              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/r.png" alt="">
                  <p>{{ $t('text.rdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dateRangeTotal.day }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/y.png" alt="">
                  <p>{{ $t('text.ydl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dateRangeTotal.month }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/n.png" alt="">
                  <p>{{ $t('text.ndl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dateRangeTotal.year }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/z.png" alt="">
                  <p>{{ $t('text.zdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dateRangeTotal.total }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.rjdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dayRateTotal.sharp }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.rifdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dayRateTotal.peak }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.rpdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dayRateTotal.flat }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.rgdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dayRateTotal.valley }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dayDvlleyEnergy') }}</p>
                  <p>{{ summaryOverview.photovoltaic.dayRateTotal.dvalley }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.jdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.rateTotal.sharp }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.pdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.rateTotal.peak }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.fdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.rateTotal.flat }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.gdl') }}</p>
                  <p>{{ summaryOverview.photovoltaic.rateTotal.valley }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dvalleyEnergy') }}</p>
                  <p>{{ summaryOverview.photovoltaic.rateTotal.dvalley }}
                  </p>
                </div>
              </el-card>
            </div>
            <div v-show="isPhotovoltaicEmptyData" class="empty-data-descript">
              <p>{{ summaryOverview.photovoltaic.emptyData }}</p>
            </div>
          </template>
        </el-card>

        <!-- 余电上网汇总 -->
        <el-card class="overview-item">
          <template #header>
            <strong>
              余电上网汇总
            </strong>
          </template>
          <template #default>
            <div v-show="!isPushPowerGridEmptyData" class="content-container">
              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/r.png" alt="">
                  <p>{{ $t('text.rdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dateRangeTotal.day }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/y.png" alt="">
                  <p>{{ $t('text.ydl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dateRangeTotal.month }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/n.png" alt="">
                  <p>{{ $t('text.ndl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dateRangeTotal.year }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/z.png" alt="">
                  <p>{{ $t('text.zdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dateRangeTotal.total }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.rjdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dayRateTotal.sharp }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.rifdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dayRateTotal.peak }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.rpdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dayRateTotal.flat }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.rgdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dayRateTotal.valley }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dayDvlleyEnergy') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.dayRateTotal.dvalley }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.jdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.rateTotal.sharp }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.pdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.rateTotal.peak }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.fdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.rateTotal.flat }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.gdl') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.rateTotal.valley }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dvalleyEnergy') }}</p>
                  <p>{{ summaryOverview.pushPowerGrid.rateTotal.dvalley }}
                  </p>
                </div>
              </el-card>
            </div>
            <div v-show="isPushPowerGridEmptyData" class="empty-data-descript">
              <p>{{ summaryOverview.pushPowerGrid.emptyData }}</p>
            </div>
          </template>
        </el-card>

        <!-- 电网买电汇总 -->
        <el-card class="overview-item">
          <template #header>
            <strong>
              电网买电汇总
            </strong>
          </template>
          <template #default>
            <div v-show="!isPullPowerGridEmptyData" class="content-container">
              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/r.png" alt="">
                  <p>{{ $t('text.rdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dateRangeTotal.day }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/y.png" alt="">
                  <p>{{ $t('text.ydl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dateRangeTotal.month }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/n.png" alt="">
                  <p>{{ $t('text.ndl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dateRangeTotal.year }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/z.png" alt="">
                  <p>{{ $t('text.zdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dateRangeTotal.total }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.rjdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dayRateTotal.sharp }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.rifdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dayRateTotal.peak }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.rpdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dayRateTotal.flat }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.rgdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dayRateTotal.valley }}</p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dayDvlleyEnergy') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.dayRateTotal.dvalley }}</p>
                </div>
              </el-card>

              <el-card class="item-panel">
                <div>
                  <img src="../../assets/icon/j1.png" alt="">
                  <p>{{ $t('text.jdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.rateTotal.sharp }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/p1.png" alt="">
                  <p>{{ $t('text.pdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.rateTotal.peak }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/f1.png" alt="">
                  <p>{{ $t('text.fdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.rateTotal.flat }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.gdl') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.rateTotal.valley }}
                  </p>
                </div>
                <div>
                  <img src="../../assets/icon/g1.png" alt="">
                  <p>{{ $t('text.dvalleyEnergy') }}</p>
                  <p>{{ summaryOverview.pullPowerGrid.rateTotal.dvalley }}
                  </p>
                </div>
              </el-card>
            </div>
            <div v-show="isPullPowerGridEmptyData" class="empty-data-descript">
              <p>{{ summaryOverview.pullPowerGrid.emptyData }}</p>
            </div>
          </template>
        </el-card>
      </div>

      <!-- 设备概览数据 -->
      <div
        v-show="!isSummary"
        v-loading="dataLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="device-overview"
      >
        <el-card class="overview-item">
          <template #header>
            <strong>
              {{ meterOriTotalTitle }}（{{ $t('text.ysds') }}: {{ meterOriTotal }}）
            </strong>
            <el-button round size="mini" class="button-trigger" @click="triggerEnergyDirection">
              {{ triggerEnergyDirectionButtonText }}
            </el-button>
          </template>
          <template #default>
            <el-card shadow="never">
              <div>
                <img src="../../assets/icon/r.png" alt="">
                <p>{{ $t('text.rdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].periodSummary.day }}</p>
              </div>
              <div>
                <img src="../../assets/icon/y.png" alt="">
                <p>{{ $t('text.ydl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].periodSummary.month }}</p>
              </div>
              <div>
                <img src="../../assets/icon/n.png" alt="">
                <p>{{ $t('text.ndl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].periodSummary.year }}</p>
              </div>
              <div>
                <img src="../../assets/icon/z.png" alt="">
                <p>{{ $t('text.zdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].periodSummary.total }}</p>
              </div>
            </el-card>

            <el-card shadow="never">
              <div>
                <img src="../../assets/icon/j1.png" alt="">
                <p>{{ $t('text.rjdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].daySummary.sharp }}</p>
              </div>
              <div>
                <img src="../../assets/icon/f1.png" alt="">
                <p>{{ $t('text.rifdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].daySummary.peak }}</p>
              </div>
              <div>
                <img src="../../assets/icon/p1.png" alt="">
                <p>{{ $t('text.rpdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].daySummary.flat }}</p>
              </div>
              <div>
                <img src="../../assets/icon/g1.png" alt="">
                <p>{{ $t('text.rgdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].daySummary.valley }}</p>
              </div>
              <div>
                <img src="../../assets/icon/g1.png" alt="">
                <p>{{ $t('text.dayDvlleyEnergy') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].daySummary.dvalley }}</p>
              </div>
            </el-card>

            <el-card shadow="never">
              <div>
                <img src="../../assets/icon/j1.png" alt="">
                <p>{{ $t('text.jdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].rateSummary.sharp }}
                </p>
              </div>
              <div>
                <img src="../../assets/icon/f1.png" alt="">
                <p>{{ $t('text.fdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].rateSummary.peak }}
                </p>
              </div>
              <div>
                <img src="../../assets/icon/p1.png" alt="">
                <p>{{ $t('text.pdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].rateSummary.flat }}
                </p>
              </div>
              <div>
                <img src="../../assets/icon/g1.png" alt="">
                <p>{{ $t('text.gdl') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].rateSummary.valley }}
                </p>
              </div>
              <div>
                <img src="../../assets/icon/g1.png" alt="">
                <p>{{ $t('text.dvalleyEnergy') }}</p>
                <p>{{ deviceOverview.energySummary[deviceOverview.energySummaryType].rateSummary.dvalley }}
                </p>
              </div>
            </el-card>
          </template>
        </el-card>
        <el-card class="overview-item">
          <template #default>
            <el-card>
              <template #header>
                <strong>
                  {{ $t('text.ssz') }}
                </strong>
              </template>
              <template #default>
                <div>
                  <p>{{ deviceOverview.instantaneous.current.a }}</p>
                  <p>{{ $t('text.axdl') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.current.b }}</p>
                  <p>{{ $t('text.bxdl') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.current.c }}</p>
                  <p>{{ $t('text.cxdl') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.fac }}</p>
                  <p>{{ $t('text.glys') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.voltage.a }}</p>
                  <p>{{ $t('text.axdy') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.voltage.b }}</p>
                  <p>{{ $t('text.bxdy') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.voltage.c }}</p>
                  <p>{{ $t('text.cxdy') }}</p>
                </div>
                <div>
                  <p>{{ deviceOverview.instantaneous.meterRatio }}</p>
                  <p>{{ $t('text.bl') }}</p>
                </div>
              </template>
            </el-card>
            <el-card>
              <template #header>
                <strong>
                  {{ powerRoseChartTitle }}
                </strong>
                <el-button
                  round
                  size="mini"
                  class="button-trigger"
                  style="margin-left: 10px;"
                  @click="triggerPowerDirection()"
                >
                  {{ triggerPowerDirectionButtonText }}
                </el-button>
              </template>
              <template #default>
                <div id="divPowerRose" style="height:100%;width:100%" />
              </template>
            </el-card>
            <el-card>
              <template #header>
                <strong>
                  无功电量
                </strong>
              </template>
              <template #default>
                <div id="divReactiveEnergy" style="height:100%;width:100%" />
              </template>
            </el-card>
          </template>
        </el-card>
        <el-card class="overview-item">
          <template #header>
            <strong>
              功率曲线
            </strong>
            <div style="display: flex; align-items: center;">
              <el-radio-group
                v-model="powerQuery.queryType"
                size="mini"
                style="height: 28px;"
                @input="getMeterPowerGraph"
              >
                <el-radio-button label="twentyFourHours" class="radio-button">24小时</el-radio-button>
                <el-radio-button label="month" class="radio-button">月</el-radio-button>
              </el-radio-group>
              <el-button
                size="mini"
                type="primary"
                class="btn-export__power"
                icon="el-icon-bottom"
                :loading="powerQuery.loading"
                :disabled="powerChart.xAxis.data.length === 0"
                @click="exportMeterPowerChartOfOverview"
              >导出</el-button>
            </div>
          </template>
          <template #default>
            <div
              v-loading="powerQuery.loading"
              style="height:100%"
              element-loading-text="图表加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <div v-show="powerChart.xAxis.data.length > 0" id="power_chart" style="height:100%;width:100%" />
              <div v-show="powerChart.xAxis.data.length === 0" class="empty-data">
                暂无数据
              </div>
            </div>
          </template>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { GetDevicesByOrgId } from '@/api/Universal'
import { GetMeterOverview, GetMeterEnergySummaryOverview, GetMeterPowerChartOfOverview, ExportMeterPowerChartOfOverview } from '@/api/Meter'
import { Option, getEchart, hostSeriesData } from '../../utils/echarts'
import dayjs from 'dayjs'
import echarts from 'echarts'
export default {
  name: 'Elemeter',
  data () {
    return {

      /** 数据加载中 */
      dataLoading: false,

      /** 设备列表 */
      device: {

        /** 设备列表 */
        list: [],

        /** 选中的设备ID */
        selectedId: 'energySummary',

        /** 额外指标列表 */
        additionList: [
          { key: '电量汇总', value: 'energySummary' },
        ],
      },

      /** 接口返回的原始值 */
      apiResponseStore: {
        tsflags: {
          sharp: "",
          peak: "",
          flat: "",
          valley: "",
          dvalley: ""
        },
        ia: 0,
        ib: 0,
        ic: 0,
        ua: 0,
        ub: 0,
        uc: 0,
        fac: {
          source: "",
          parsedValue: 0
        },
        fac1: {
          source: "",
          parsedValue: 0
        },
        fac2: {
          source: "",
          parsedValue: 0
        },
        fac3: {
          source: "",
          parsedValue: 0
        },
        mrate: {
          source: "",
          parsedValue: 0
        },
        pac: 0,
        pac1: 0,
        pac2: 0,
        pac3: 0,
        prc: 0,
        prc1: 0,
        prc2: {
          source: "",
          parsedValue: 0
        },
        prc3: 0,
        powers: null,
        fsharp: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fpeak: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fflat: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fdvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fetoday: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        femonth: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        feyear: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        fetotal: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orifsharp: {
          orivalue: 0,
          cvalue: [
            "",
            "KWh"
          ]
        },
        orifpeak: {
          orivalue: 0,
          cvalue: [
            "",
            "KWh"
          ]
        },
        orifflat: {
          orivalue: 0,
          cvalue: [
            "",
            "KWh"
          ]
        },
        orifvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orifdvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        oriftotal: {
          orivalue: 0,
          cvalue: [
            "",
            "KWh"
          ]
        },
        rsharp: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        rpeak: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        rfflat: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        rvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        rdvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        retoday: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        remonth: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        reyear: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        retotal: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirsharp: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirpeak: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirflat: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirdvalley: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        orirtotal: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "KWh"
          ]
        },
        re1t: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "kvarh"
          ]
        },
        re2t: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "kvarh"
          ]
        },
        re3t: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "kvarh"
          ]
        },
        re4t: {
          orivalue: {
            source: "",
            parsedValue: 0
          },
          cvalue: [
            "",
            "kvarh"
          ]
        },
        edays: {
          fflat: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          fpeak: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          fsharp: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          ftotal: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          fvalley: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          fdvalley: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rflat: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rpeak: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rsharp: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rtotal: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rvalley: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          },
          rdvalley: {
            orivalue: {
              source: "",
              parsedValue: 0
            },
            cvalue: [
              "",
              "KWh"
            ]
          }
        }
      },

      /** 设备概览数据 */
      deviceOverview: {

        /** 电量汇总-显示类型 */
        energySummaryType: 'forward',
        /** 电量汇总 */
        energySummary: {

          /** 电量汇总-正向 */
          forward: {

            /** 电量汇总-总读数 */
            oriTotal: '',

            /** 电量汇总-周期 */
            periodSummary: {
              day: '',
              month: '',
              year: '',
              total: '',
            },

            /** 电量汇总-当日 */
            daySummary: {
              sharp: '',
              peak: '',
              flat: '',
              valley: '',
              dvalley: '',
              total: '',
            },

            /** 电量汇总-费率 */
            rateSummary: {
              sharp: '',
              peak: '',
              flat: '',
              valley: '',
              dvalley: '',
              total: '',
            }
          },

          /** 电量汇总-反向 */
          reverse: {

            /** 电量汇总-总读数 */
            oriTotal: '',

            /** 电量汇总-周期 */
            periodSummary: {
              day: '',
              month: '',
              year: '',
              total: '',
            },

            /** 电量汇总-当日 */
            daySummary: {
              sharp: '',
              peak: '',
              flat: '',
              valley: '',
              dvalley: '',
              total: '',
            },

            /** 电量汇总-费率 */
            rateSummary: {
              sharp: '',
              peak: '',
              flat: '',
              valley: '',
              dvalley: '',
              total: '',
            }
          },
        },

        /** 瞬时值 */
        instantaneous: {

          /** 瞬时值-电流*/
          current: {
            a: '',
            b: '',
            c: '',
          },
          /** 瞬时值-电压*/
          voltage: {
            a: '',
            b: '',
            c: '',
          },

          /** 瞬�时值-功率因数*/
          fac: '',

          /** 瞬时值-电表倍率*/
          meterRatio: '',
        },

        /** 瞬时值-功率类型 */
        instantaneousPowerType: 'active',

        /** 瞬时值-功率*/
        instantaneousPower: {
          /** 瞬时值-有功功率*/
          active: {
            a: '',
            b: '',
            c: '',
            total: '',
          },
          /** 瞬时值-无功功率*/
          reactive: {
            a: '',
            b: '',
            c: '',
            total: '',
          },
        },

        /** 瞬时值-无功电量*/
        reactivePowerEnergy: {
          quadrant1: '',
          quadrant2: '',
          quadrant3: '',
          quadrant4: '',
        },

        /** 功率曲线 */
        powerCurve: []
      },

      /** 汇总概览数据 */
      summaryOverview: {

        /** 光伏发电 */
        photovoltaic: {

          /** 时间范围总电量 */
          dateRangeTotal: {
            day: '0',
            month: '0',
            year: '0',
            total: '0',
          },

          /** 日费率总电量 */
          dayRateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0'
          },

          /** 费率总电量 */
          rateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0',
            total: '0',
          },

          /** 数据是否存在 */
          emptyData: ''
        },

        /** 余电上网 */
        pushPowerGrid: {

          /** 时间范围总电量 */
          dateRangeTotal: {
            day: '0',
            month: '0',
            year: '0',
            total: '0',
          },

          /** 日费率总电量 */
          dayRateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0',
            total: '0',
          },

          /** 费率总电量 */
          rateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0',
            total: '0',
          },

          /** 数据是否存在 */
          emptyData: ''
        },

        /** 电网买电 */
        pullPowerGrid: {

          /** 时间范围总电量 */
          dateRangeTotal: {
            day: '0',
            month: '0',
            year: '0',
            total: '0',
          },

          /** 日费率总电量 */
          dayRateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0',
            total: '0',
          },

          /** 费率总电量 */
          rateTotal: {
            sharp: '0',
            peak: '0',
            flat: '0',
            valley: '0',
            dvalley: '0',
            total: '0',
          },

          /** 数据是否存在 */
          emptyData: ''
        }
      },

      /** 功率曲线查询参数 */
      powerQuery: {
        loading: false,
        queryType: 'twentyFourHours',
        hasInit: false,
        renderKey: Math.random()
      },

      /** 功率曲线图表配置 */
      powerChart: {
        color: ['#009688', '#FF5722'],
        grid: {
          top: '20',
          right: '20',
          bottom: '20',
          left: '160'
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        legend: {
          data: [{
            name: '有功功率',
            textStyle: {
              color: '#009688'
            }
          }, {
            name: '无功功率',
            textStyle: {
              color: '#FF5722'
            }
          }],
          orient: 'vertical',
          left: '10',
          bottom: 'center'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#ffffff'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#ffffff',
            formatter: (params) => {
              return params + 'kW'
            }
          }
        },
        series: [{
          data: [],
          name: '有功功率',
          type: 'line',
          smooth: true,
          symbol: 'none'
        }, {
          data: [],
          name: '无功功率',
          type: 'line',
          smooth: true,
          symbol: 'none'
        }]
      },

      /** 功率曲线图表元素 */
      powerChartsElement: null
    }
  },
  computed: {

    /** 电表原始读数 */
    meterOriTotal () {
      const value = this.deviceOverview.energySummaryType === 'forward' ? this.apiResponseStore.oriftotal : this.apiResponseStore.orirtotal
      return this.formatNumberUnit(value)
    },

    /** 电表原始读数标题 */
    meterOriTotalTitle () {
      return this.deviceOverview.energySummaryType === 'forward' ? this.$t('text.zxdl') : this.$t('text.fxdl')
    },

    /** 切换能量方向按钮文本 */
    triggerEnergyDirectionButtonText () {
      return this.deviceOverview.energySummaryType === 'forward' ? this.$t('text.fxdl') : this.$t('text.zxdl')
    },

    /** 功率曲线标题 */
    powerRoseChartTitle () {
      return this.deviceOverview.instantaneousPowerType === 'reactive' ? this.$t('text.wggl') : this.$t('text.yggl')
    },

    /** 切换功率方向按钮文本 */
    triggerPowerDirectionButtonText () {
      return this.deviceOverview.instantaneousPowerType === 'reactive' ? this.$t('text.yggl') : this.$t('text.wggl')
    },

    /** 是否是汇总概览 */
    isSummary () {
      return this.device.selectedId === this.device.additionList[0].value
    },

    /** 光伏发电数据是否存在 */
    isPhotovoltaicEmptyData () {
      return !!this.summaryOverview.photovoltaic.emptyData
    },

    /** 余电上网数据是否存在 */
    isPushPowerGridEmptyData () {
      return !!this.summaryOverview.pushPowerGrid.emptyData
    },

    /** 电网买电数据是否存在 */
    isPullPowerGridEmptyData () {
      return !!this.summaryOverview.pullPowerGrid.emptyData
    }
  },
  mounted () {
    this.getDeviceList().then(() => {
      this.getOverviewData()
    })
  },
  methods: {

    /** 格式化瞬时值 */
    formatInstantaneous (value, unit) {
      return value === null || value === -1 ? 'N/A' : value + unit
    },

    /** 格式化数字单位 */
    formatNumberUnit (value) {
      return value && value.cvalue ? value.cvalue[0] + value.cvalue[1] : '0kWh'
    },

    /** 切换能量方向 */
    triggerEnergyDirection () {
      this.deviceOverview.energySummaryType = this.deviceOverview.energySummaryType === 'forward' ? 'reverse' : 'forward'
    },

    /** 切换功率方向 */
    triggerPowerDirection () {
      this.deviceOverview.instantaneousPowerType = this.deviceOverview.instantaneousPowerType === 'active' ? 'reactive' : 'active'
      this.renderPowerRoseChart()
    },

    /** 获取电站设备列表 */
    getDeviceList () {
      return new Promise((resolve, reject) => {
        const postData = {
          id: this.$store.getters.station.id,
          tag: '3'
        }
        this.dataLoading = true
        GetDevicesByOrgId(postData).then(res => {
          const responseData = res.data || []
          const deviceList = responseData.length > 0 ? this.device.additionList.concat(responseData) : []
          if (deviceList.length > 0) {
            this.device.list = deviceList
            this.device.selectedId = this.device.list[0].value || null
          }
          resolve()
        }).catch(() => {
          reject()
        }).finally(() => {
          this.dataLoading = false
        })
      })
    },

    /** 设备选中变化回调 */
    handleDeviceChange () {
      this.getOverviewData()
    },

    /** 获取电表设备概览数据 */
    getOverviewData () {
      if (!this.device.selectedId) {
        this.$msgSuccess(this.$t('notice.sblbwk'))
      } else if (this.device.selectedId !== 'energySummary') {
        this.dataLoading = true
        GetMeterOverview({ id: this.device.selectedId })
          .then(res => {
            this.setDeviceOverView(res.data).setData()
            this.renderPowerRoseChart()
            this.renderReactivePowerEnergyRoseChart()
            this.getMeterPowerGraph()
            this.dataLoading = false
          }).catch(() => {
            this.dataLoading = false
          })
      } else {
        this.dataLoading = true
        GetMeterEnergySummaryOverview({ orgId: this.$store.getters.station.id })
          .then(res => {
            this.setSummaryOverView(res.data).setSummaryOverView()
            this.dataLoading = false
          }).catch(() => {
            this.dataLoading = false
          })
      }
    },

    /** 渲染功率玫瑰图 */
    renderPowerRoseChart () {
      const { active, reactive } = this.deviceOverview.instantaneousPower || {}
      if (this.deviceOverview.instantaneousPowerType === 'reactive') {
        Option.roseWOption.series[0].data[0].value = reactive.total
        Option.roseWOption.series[0].data[1].value = reactive.a
        Option.roseWOption.series[0].data[2].value = reactive.b
        Option.roseWOption.series[0].data[3].value = reactive.c
        if (reactive.total === 0 && reactive.a === 0 && reactive.b === 0 && reactive.c === 0) {
          Option.roseWOption.tooltip.show = false
          Option.roseWOption.series[0].hoverAnimation = false
        } else {
          Option.roseWOption.series[0].radius = [0, 75]
          Option.roseWOption.tooltip.show = true
          Option.roseWOption.series[0].hoverAnimation = true
        }
        getEchart(this.$echarts, 'divPowerRose', Option.roseWOption)
      } else {
        Option.roseYOption.series[0].data[0].value = active.total
        Option.roseYOption.series[0].data[1].value = active.a
        Option.roseYOption.series[0].data[2].value = active.b
        Option.roseYOption.series[0].data[3].value = active.c
        if (active.total === 0 && active.a === 0 && active.b === 0 && active.c === 0) {
          Option.roseYOption.series[0].radius = [0, 150]
          Option.roseYOption.tooltip.show = false
          Option.roseYOption.series[0].hoverAnimation = false
        } else {
          Option.roseYOption.series[0].radius = [0, 75]
          Option.roseYOption.tooltip.show = true
          Option.roseYOption.series[0].hoverAnimation = true
        }
        getEchart(this.$echarts, 'divPowerRose', Option.roseYOption)
      }
    },

    /** 渲染无功电量玫瑰图 */
    renderReactivePowerEnergyRoseChart () {
      Option.retOption.series[0].data[0].value = this.apiResponseStore.re1t.cvalue[0]
      Option.retOption.series[0].data[1].value = this.apiResponseStore.re2t.cvalue[0]
      Option.retOption.series[0].data[2].value = this.apiResponseStore.re3t.cvalue[0]
      Option.retOption.series[0].data[3].value = this.apiResponseStore.re4t.cvalue[0]
      hostSeriesData[0].value = this.deviceOverview.reactivePowerEnergy.quadrant1
      hostSeriesData[1].value = this.deviceOverview.reactivePowerEnergy.quadrant2
      hostSeriesData[2].value = this.deviceOverview.reactivePowerEnergy.quadrant3
      hostSeriesData[3].value = this.deviceOverview.reactivePowerEnergy.quadrant4
      Option.retOption.tooltip.show = hostSeriesData.filter(item => item.value === 'NA').length === 0
      Option.retOption.series[0].hoverAnimation = hostSeriesData.filter(item => item.value === 'NA').length === 0
      getEchart(this.$echarts, 'divReactiveEnergy', Option.retOption)
    },

    /** 设置设备概览数据 */
    setDeviceOverView (data) {
      data.ia = this.formatInstantaneous(data.ia, 'A')
      data.ib = this.formatInstantaneous(data.ib, 'A')
      data.ic = this.formatInstantaneous(data.ic, 'A')
      data.ua = this.formatInstantaneous(data.ua, 'V')
      data.ub = this.formatInstantaneous(data.ub, 'V')
      data.uc = this.formatInstantaneous(data.uc, 'V')
      data.fac = this.formatInstantaneous(data.fac, '')
      this.apiResponseStore = data || {}

      /** 设置设备电量汇总概览数据-正向 */
      const setEnergySummaryForward = () => {
        this.deviceOverview.energySummary.forward.oriTotal = this.formatNumberUnit(this.apiResponseStore.oriftotal)
        this.deviceOverview.energySummary.forward.periodSummary.day = this.formatNumberUnit(this.apiResponseStore.fetoday)
        this.deviceOverview.energySummary.forward.periodSummary.month = this.formatNumberUnit(this.apiResponseStore.femonth)
        this.deviceOverview.energySummary.forward.periodSummary.year = this.formatNumberUnit(this.apiResponseStore.feyear)
        this.deviceOverview.energySummary.forward.periodSummary.total = this.formatNumberUnit(this.apiResponseStore.fetotal)

        this.deviceOverview.energySummary.forward.daySummary.sharp = this.formatNumberUnit(this.apiResponseStore.edays.fsharp)
        this.deviceOverview.energySummary.forward.daySummary.peak = this.formatNumberUnit(this.apiResponseStore.edays.fpeak)
        this.deviceOverview.energySummary.forward.daySummary.flat = this.formatNumberUnit(this.apiResponseStore.edays.fflat)
        this.deviceOverview.energySummary.forward.daySummary.valley = this.formatNumberUnit(this.apiResponseStore.edays.fvalley)
        this.deviceOverview.energySummary.forward.daySummary.dvalley = this.formatNumberUnit(this.apiResponseStore.edays.fdvalley)
        this.deviceOverview.energySummary.forward.daySummary.total = this.formatNumberUnit(this.apiResponseStore.edays.ftotal)

        this.deviceOverview.energySummary.forward.rateSummary.sharp = this.formatNumberUnit(this.apiResponseStore.fsharp)
        this.deviceOverview.energySummary.forward.rateSummary.peak = this.formatNumberUnit(this.apiResponseStore.fpeak)
        this.deviceOverview.energySummary.forward.rateSummary.flat = this.formatNumberUnit(this.apiResponseStore.fflat)
        this.deviceOverview.energySummary.forward.rateSummary.valley = this.formatNumberUnit(this.apiResponseStore.fvalley)
        this.deviceOverview.energySummary.forward.rateSummary.dvalley = this.formatNumberUnit(this.apiResponseStore.fdvalley)
        this.deviceOverview.energySummary.forward.rateSummary.total = this.formatNumberUnit(this.apiResponseStore.ftotal)
      }

      /** 设置设备电量汇总概览数据-反向 */
      const setEnergySummaryReverse = () => {
        this.deviceOverview.energySummary.reverse.oriTotal = this.formatNumberUnit(this.apiResponseStore.orirtotal)
        this.deviceOverview.energySummary.reverse.periodSummary.day = this.formatNumberUnit(this.apiResponseStore.retoday)
        this.deviceOverview.energySummary.reverse.periodSummary.month = this.formatNumberUnit(this.apiResponseStore.remonth)
        this.deviceOverview.energySummary.reverse.periodSummary.year = this.formatNumberUnit(this.apiResponseStore.reyear)
        this.deviceOverview.energySummary.reverse.periodSummary.total = this.formatNumberUnit(this.apiResponseStore.retotal)

        this.deviceOverview.energySummary.reverse.daySummary.sharp = this.formatNumberUnit(this.apiResponseStore.edays.rsharp)
        this.deviceOverview.energySummary.reverse.daySummary.peak = this.formatNumberUnit(this.apiResponseStore.edays.rpeak)
        this.deviceOverview.energySummary.reverse.daySummary.flat = this.formatNumberUnit(this.apiResponseStore.edays.rflat)
        this.deviceOverview.energySummary.reverse.daySummary.valley = this.formatNumberUnit(this.apiResponseStore.edays.rvalley)
        this.deviceOverview.energySummary.reverse.daySummary.dvalley = this.formatNumberUnit(this.apiResponseStore.edays.rdvalley)
        this.deviceOverview.energySummary.reverse.daySummary.total = this.formatNumberUnit(this.apiResponseStore.edays.rtotal)

        this.deviceOverview.energySummary.reverse.rateSummary.sharp = this.formatNumberUnit(this.apiResponseStore.rsharp)
        this.deviceOverview.energySummary.reverse.rateSummary.peak = this.formatNumberUnit(this.apiResponseStore.rpeak)
        this.deviceOverview.energySummary.reverse.rateSummary.flat = this.formatNumberUnit(this.apiResponseStore.rfflat)
        this.deviceOverview.energySummary.reverse.rateSummary.valley = this.formatNumberUnit(this.apiResponseStore.rvalley)
        this.deviceOverview.energySummary.reverse.rateSummary.dvalley = this.formatNumberUnit(this.apiResponseStore.rdvalley)
        this.deviceOverview.energySummary.reverse.rateSummary.total = this.formatNumberUnit(this.apiResponseStore.rtotal)
      }

      /** 设置设备瞬时数据概览数据 */
      const setInstantaneous = () => {
        this.deviceOverview.instantaneous.current.a = this.apiResponseStore.ia
        this.deviceOverview.instantaneous.current.b = this.apiResponseStore.ib
        this.deviceOverview.instantaneous.current.c = this.apiResponseStore.ic
        this.deviceOverview.instantaneous.voltage.a = this.apiResponseStore.ua
        this.deviceOverview.instantaneous.voltage.b = this.apiResponseStore.ub
        this.deviceOverview.instantaneous.voltage.c = this.apiResponseStore.uc
        this.deviceOverview.instantaneous.fac = this.apiResponseStore.fac
        this.deviceOverview.instantaneous.meterRatio = this.apiResponseStore.mrate
      }

      /** 设置设备瞬时数据-功率 */
      const setInstantaneousPower = () => {
        this.deviceOverview.instantaneousPower.active.a = this.apiResponseStore.pac1
        this.deviceOverview.instantaneousPower.active.b = this.apiResponseStore.pac2
        this.deviceOverview.instantaneousPower.active.c = this.apiResponseStore.pac3
        this.deviceOverview.instantaneousPower.active.total = this.apiResponseStore.pac

        this.deviceOverview.instantaneousPower.reactive.a = this.apiResponseStore.prc1
        this.deviceOverview.instantaneousPower.reactive.b = this.apiResponseStore.prc2
        this.deviceOverview.instantaneousPower.reactive.c = this.apiResponseStore.prc3
        this.deviceOverview.instantaneousPower.reactive.total = this.apiResponseStore.prc
      }

      /** 设置设备瞬时数据-无功功率-四象限 */
      const setReactivePowerEnergy = () => {
        this.deviceOverview.reactivePowerEnergy.quadrant1 = Number(this.apiResponseStore.re1t.cvalue[0]) < 0 ? 'NA' : this.apiResponseStore.re1t.cvalue[0]
        this.deviceOverview.reactivePowerEnergy.quadrant2 = Number(this.apiResponseStore.re2t.cvalue[0]) < 0 ? 'NA' : this.apiResponseStore.re2t.cvalue[0]
        this.deviceOverview.reactivePowerEnergy.quadrant3 = Number(this.apiResponseStore.re3t.cvalue[0]) < 0 ? 'NA' : this.apiResponseStore.re3t.cvalue[0]
        this.deviceOverview.reactivePowerEnergy.quadrant4 = Number(this.apiResponseStore.re4t.cvalue[0]) < 0 ? 'NA' : this.apiResponseStore.re4t.cvalue[0]
      }

      /** 设置设备概览数据 */
      const setData = () => {
        setEnergySummaryForward()
        setEnergySummaryReverse()
        setInstantaneous()
        setInstantaneousPower()
        setReactivePowerEnergy()
      }

      return {
        setData
      }
    },

    /** 设置汇总概览数据 */
    setSummaryOverView (data) {
      const responseData = data || {}

      /** 设置汇总概览数据-光伏发电 */
      const setPhotovoltaic = () => {
        const { dateRange, daySummary, rateEnergy, emptyDescript } = responseData.photovoltaicPower
        this.summaryOverview.photovoltaic.emptyData = emptyDescript
        if (!emptyDescript) {
          this.summaryOverview.photovoltaic.dateRangeTotal.day = this.formatNumberUnit(dateRange.daySummary)
          this.summaryOverview.photovoltaic.dateRangeTotal.month = this.formatNumberUnit(dateRange.monthSummary)
          this.summaryOverview.photovoltaic.dateRangeTotal.year = this.formatNumberUnit(dateRange.yearSummary)
          this.summaryOverview.photovoltaic.dateRangeTotal.total = this.formatNumberUnit(dateRange.totalSummary)

          this.summaryOverview.photovoltaic.dayRateTotal.sharp = this.formatNumberUnit(daySummary.daySharp)
          this.summaryOverview.photovoltaic.dayRateTotal.peak = this.formatNumberUnit(daySummary.dayPeak)
          this.summaryOverview.photovoltaic.dayRateTotal.flat = this.formatNumberUnit(daySummary.dayFlat)
          this.summaryOverview.photovoltaic.dayRateTotal.valley = this.formatNumberUnit(daySummary.dayValley)
          this.summaryOverview.photovoltaic.dayRateTotal.dvalley = this.formatNumberUnit(daySummary.dayDvalley)

          this.summaryOverview.photovoltaic.rateTotal.sharp = this.formatNumberUnit(rateEnergy.sharpTotal)
          this.summaryOverview.photovoltaic.rateTotal.peak = this.formatNumberUnit(rateEnergy.peakTotal)
          this.summaryOverview.photovoltaic.rateTotal.flat = this.formatNumberUnit(rateEnergy.flatTotal)
          this.summaryOverview.photovoltaic.rateTotal.valley = this.formatNumberUnit(rateEnergy.valleyTotal)
          this.summaryOverview.photovoltaic.rateTotal.dvalley = this.formatNumberUnit(rateEnergy.dvalleyTotal)
        }
      }

      /** 设置汇总概览数据-电网推送电量汇总 */
      const setPushPowerGrid = () => {
        const { dateRange, daySummary, rateEnergy, emptyDescript } = responseData.pushGridPower
        this.summaryOverview.pushPowerGrid.emptyData = emptyDescript
        if (!emptyDescript) {
          this.summaryOverview.pushPowerGrid.dateRangeTotal.day = this.formatNumberUnit(dateRange.daySummary)
          this.summaryOverview.pushPowerGrid.dateRangeTotal.month = this.formatNumberUnit(dateRange.monthSummary)
          this.summaryOverview.pushPowerGrid.dateRangeTotal.year = this.formatNumberUnit(dateRange.yearSummary)
          this.summaryOverview.pushPowerGrid.dateRangeTotal.total = this.formatNumberUnit(dateRange.totalSummary)

          this.summaryOverview.pushPowerGrid.dayRateTotal.sharp = this.formatNumberUnit(daySummary.daySharp)
          this.summaryOverview.pushPowerGrid.dayRateTotal.peak = this.formatNumberUnit(daySummary.dayPeak)
          this.summaryOverview.pushPowerGrid.dayRateTotal.flat = this.formatNumberUnit(daySummary.dayFlat)
          this.summaryOverview.pushPowerGrid.dayRateTotal.valley = this.formatNumberUnit(daySummary.dayValley)
          this.summaryOverview.pushPowerGrid.dayRateTotal.dvalley = this.formatNumberUnit(daySummary.dayDvalley)

          this.summaryOverview.pushPowerGrid.rateTotal.sharp = this.formatNumberUnit(rateEnergy.sharpTotal)
          this.summaryOverview.pushPowerGrid.rateTotal.peak = this.formatNumberUnit(rateEnergy.peakTotal)
          this.summaryOverview.pushPowerGrid.rateTotal.flat = this.formatNumberUnit(rateEnergy.flatTotal)
          this.summaryOverview.pushPowerGrid.rateTotal.valley = this.formatNumberUnit(rateEnergy.valleyTotal)
          this.summaryOverview.pushPowerGrid.rateTotal.dvalley = this.formatNumberUnit(rateEnergy.dvalleyTotal)
        }
      }

      /** 设置汇总概览数据-电网拉取电量汇总 */
      const setPullPowerGrid = () => {
        const { dateRange, daySummary, rateEnergy, emptyDescript } = responseData.pullGridPower
        this.summaryOverview.pullPowerGrid.emptyData = emptyDescript
        if (!emptyDescript) {
          this.summaryOverview.pullPowerGrid.dateRangeTotal.day = this.formatNumberUnit(dateRange.daySummary)
          this.summaryOverview.pullPowerGrid.dateRangeTotal.month = this.formatNumberUnit(dateRange.monthSummary)
          this.summaryOverview.pullPowerGrid.dateRangeTotal.year = this.formatNumberUnit(dateRange.yearSummary)
          this.summaryOverview.pullPowerGrid.dateRangeTotal.total = this.formatNumberUnit(dateRange.totalSummary)

          this.summaryOverview.pullPowerGrid.dayRateTotal.sharp = this.formatNumberUnit(daySummary.daySharp)
          this.summaryOverview.pullPowerGrid.dayRateTotal.peak = this.formatNumberUnit(daySummary.dayPeak)
          this.summaryOverview.pullPowerGrid.dayRateTotal.flat = this.formatNumberUnit(daySummary.dayFlat)
          this.summaryOverview.pullPowerGrid.dayRateTotal.valley = this.formatNumberUnit(daySummary.dayValley)
          this.summaryOverview.pullPowerGrid.dayRateTotal.dvalley = this.formatNumberUnit(daySummary.dayDvalley)

          this.summaryOverview.pullPowerGrid.rateTotal.sharp = this.formatNumberUnit(rateEnergy.sharpTotal)
          this.summaryOverview.pullPowerGrid.rateTotal.peak = this.formatNumberUnit(rateEnergy.peakTotal)
          this.summaryOverview.pullPowerGrid.rateTotal.flat = this.formatNumberUnit(rateEnergy.flatTotal)
          this.summaryOverview.pullPowerGrid.rateTotal.valley = this.formatNumberUnit(rateEnergy.valleyTotal)
          this.summaryOverview.pullPowerGrid.rateTotal.dvalley = this.formatNumberUnit(rateEnergy.dvalleyTotal)
        }
      }

      /** 设置汇总概览数据 */
      const setSummaryOverView = () => {
        setPhotovoltaic()
        setPushPowerGrid()
        setPullPowerGrid()
      }
      return {
        setSummaryOverView
      }
    },

    /** 获取电表历史有功功率总和无功功率总读数 */
    getMeterPowerGraph () {
      if (this.device.selectedId !== 'energySummary') {
        this.powerQuery.loading = true
        this.powerChart.xAxis.data = []
        this.powerChart.series[0].data = []
        this.powerChart.series[1].data = []
        const postData = {
          deviceId: this.device.selectedId,
          queryType: this.powerQuery.queryType
        }
        GetMeterPowerChartOfOverview(postData)
          .then(response => {
            let hasData = false
            const { data } = response
            if (data && data.length > 0) {
              const timeFormat = this.powerQuery.queryType === 'month' ? 'YYYY-MM-DD HH:mm' : 'HH:mm'
              this.powerChart.xAxis.data = data.map(item => dayjs(item.time).format(timeFormat))
              this.powerChart.series[0].data = data.map(item => item.val1)
              this.powerChart.series[1].data = data.map(item => item.val2)
              hasData = true
            }
            return hasData
          }).then((hasData) => {
            if (hasData) {
              if (!this.powerChartsElement) {
                this.powerChartsElement = echarts.init(document.getElementById('power_chart'))
              }
              this.powerChartsElement.setOption(this.powerChart)
            }
          }).then(() => {
            this.powerQuery.loading = false
          }).catch(() => {
            this.powerQuery.loading = false
          })
      }
    },

    /** 导出功率曲线 */
    exportMeterPowerChartOfOverview () {
      this.powerQuery.loading = true
      const postData = {
        deviceId: this.device.selectedId,
        queryType: this.powerQuery.queryType
      }
      ExportMeterPowerChartOfOverview(postData).then(response => {
        const { data } = response
        const link = document.createElement('a')
        link.href = data
        link.click()
        document.removeChild(link)
      }).finally(() => {
        this.powerQuery.loading = false
      })
    }
  }
}
</script>

<style scoped>
.device-select__container {
  position: absolute;
  top: 19px;
  right: 30px;
  width: 260px;
  z-index: 99;
}
</style>
<style scoped>
.device-overview {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}
.device-overview .overview-item {
  width: 100%;
  height: 100%;
  background-color: #1d3666;
  border-color: #0d2d59;
  color: #fff;
}
.device-overview .overview-item >>>.el-card__header {
  border-bottom: none;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  padding: 0 20px;
}
.device-overview .overview-item >>>.el-card__header::before {
  content: "";
  width: 5px;
  height: 20px;
  background-color: #1fd09d;
  position: absolute;
  left: 10px;
}
.device-overview .overview-item >>>.el-card__header .button-trigger {
  color: #fff;
  background-color: #175e77;
  border: none;
}

.device-overview .overview-item:nth-of-type(1){
  grid-area: 1/1/1/4;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__header {
   width: 100%;
   height: 50px;
   padding: 0 20px;
   box-sizing: border-box;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__body {
   width: 100%;
   height: calc(100% - 50px);
   padding: 0 20px 10px;
   box-sizing: border-box;
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   grid-gap: 10px;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__body .el-card{
   width: 100%;
   height: 100%;
   padding: 0px;
   box-sizing: border-box;
   background-color: #0d2d59;
   border-color: #0d2d59;
   color: #fff;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__body .el-card .el-card__body{
   width: 100%;
   height: 100%;
   padding: 0 15px;
   box-sizing: border-box;
   display: grid;
   grid-template-rows: repeat(2, 1fr);
   grid-template-columns: repeat(3, 1fr);
   grid-gap: 10px;
   align-items: center;
   text-align: center;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__body .el-card .el-card__body img{
  width: 25px;
  height: 25px;
}
.device-overview .overview-item:nth-of-type(1) >>>.el-card__body .el-card:nth-of-type(1) .el-card__body{
  grid-template-columns: repeat(2, 1fr);
}

.device-overview .overview-item:nth-of-type(2){
  grid-area: 2/1/2/4;
  background-color: transparent;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #0d2d59;
  color: #ffffff;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card .el-card__header {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0px;
  box-sizing: border-box;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card:nth-of-type(1) .el-card__body {
  padding: 0 20px 10px;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card:nth-of-type(1) .el-card__body div {
  background-color: #162b5e;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card:nth-of-type(2) .el-card__body,
.device-overview .overview-item:nth-of-type(2) >>>.el-card__body .el-card:nth-of-type(3) .el-card__body {
  display: block;
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px 10px;
  box-sizing: border-box;
}

.device-overview .overview-item:nth-of-type(3){
  grid-area: 3/1/3/4;
}
.device-overview .overview-item:nth-of-type(3) >>>.el-card__header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.device-overview .overview-item:nth-of-type(3) >>>.el-card__body {
  padding-top: 0;
}
.device-overview .overview-item:nth-of-type(3) >>>.el-card__body .empty-data {
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   color: #1fd09d;
}
.device-overview .overview-item:nth-of-type(3) .btn-export__power {
  height: 28px;
  margin-left: 10px;
}

</style>
<style scoped>
.summary-overview {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 10px;
}
.summary-overview .overview-item {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
  color: #fff;
}
.summary-overview .overview-item >>>.el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
.summary-overview .overview-item >>>.el-card__header::before {
  content: "";
  width: 5px;
  height: 20px;
  background-color: #1fd09d;
  position: absolute;
  left: 10px;
}

.summary-overview .overview-item >>>.el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px 10px;
  box-sizing: border-box;
}
.summary-overview .overview-item >>>.el-card__body .empty-data-descript {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.summary-overview .overview-item >>>.el-card__body .content-container {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}
.summary-overview .overview-item >>>.el-card__body .content-container .item-panel{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #0D2D59 ;
  border-color: #0D2D59;
}

.summary-overview .overview-item >>>.el-card__body .content-container .item-panel .el-card__body {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  align-items: center;
  background-color: #0D2D59 ;
  border-color: #0D2D59;
  color: #ffffff;
  text-align: center;
}

.summary-overview .overview-item >>>.el-card__body .content-container .item-panel .el-card__body img {
  width: 25px;
  height: 25px;
}

.summary-overview .overview-item >>>.el-card__body .content-container .item-panel:nth-of-type(1) .el-card__body{
  grid-template-columns: repeat(2, 1fr);
}

</style>
